import { CircularProgress, Flex, Text } from "@chakra-ui/react"

type TransactionProgressLoaderProps = {
  text: string
  textVariant?: string
  color?: string
  size?: string
  gap?: number | string
}

export default function TransactionProgressLoader({
  text,
  textVariant,
  color = "primary.white.100",
  size = "24px",
  gap = 4,
}: TransactionProgressLoaderProps) {
  return (
    <Flex alignItems="center" gap={gap}>
      <CircularProgress
        isIndeterminate
        color={color}
        trackColor="transparent"
        size={size}
        thickness="12px"
      />
      <Text color={color} variant={textVariant}>
        {text}
      </Text>
    </Flex>
  )
}
